import { Dispatch, SetStateAction, useState } from 'react';
import { Ligacao } from './ligacao';

import React from 'react';



export const Chat = () => {
  const [chat, setChat] = useState('Ligação');
  // const { devedorFilaSelected } = useFila()

  // ${isOpen ? 'translate-x-0 ' : 'translate-x-full'}


  return (
    <div
      className={`fixed bottom-0 right-0 z-50  h-chatBar w-[20vw] border bg-white py-2  text-gray-800  duration-300 ease-in-out translate-x-0 `}
    >
      {
        chat !== '' && (
          <div className="mb-4 mt-8 grid w-full grid-cols-4 gap-1 px-2 text-xs">

            <button
              className={`${chat === 'Ligação' ? 'bg-green-600 text-white ' : 'bg-white text-gray-800 '
                } my-2 rounded px-2 py-2 text-center font-medium`}
              onClick={() => setChat('Ligação')}
            >
              Ligação
            </button>

          </div>
        )
      }


      <div className="flex h-full w-full items-center justify-center ">
        {/* {chat === 'WhatsApp' && <ChatBox type="whatsapp" />}
        {/* {chat === "SMS" && <ChatBox type="sms" />} */}
        {/* {chat === 'SMS' && <ChatNotConnect />} */}
        {chat === 'Ligação' && <Ligacao />}
        {/* {chat === 'E-mail' && <Email />}
        {chat === '' && <DefaultChat handleChoice={handleChoice} />} */}
      </div>
    </div>
  );
};
